module.exports = {
  title: 'Expandable Mini Player with Reanimated',
  author: 'Enzo Manuel Mangano',
  date: '2024-10-29',
  slug: 'expandable-mini-player',
  tags: ['reanimated'],
};
